import { render, staticRenderFns } from "./WSurveyBuilder.vue?vue&type=template&id=3eaa63d0&"
import script from "./WSurveyBuilder.vue?vue&type=script&lang=ts&"
export * from "./WSurveyBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports